import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { queryKeys, type AnnouncementsListFilters } from '@/core/data-fetching/queryKeys';
import { announcementsService } from '../api/announcements.service';

export function useAnnouncementsListQuery(filters: AnnouncementsListFilters) {
  return useQuery({
    queryKey: queryKeys.announcements.list(filters),
    queryFn: () => announcementsService.list(filters),
    placeholderData: keepPreviousData,
  });
}

export function useAnnouncementDetailQuery(id: string | null, enabled = true) {
  return useQuery({
    queryKey: queryKeys.announcements.detail(id ?? ''),
    queryFn: () => announcementsService.get(id!),
    enabled: Boolean(id) && enabled,
  });
}
